import { BACKEND } from "../../config/configEnvs";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FaPhone, FaUserAlt, FaCalendar, FaClock, FaPhoneAlt, FaMicrophone } from "react-icons/fa";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import CallSection from "./CallSection";

const LlamadasSeguimiento = ({serviceQuoteId, clientData, isAdmin, userId, userArea}) => {

  const [calls, setCalls] = useState([]);

  const getCalls = async () => {
    try {

      let url = ""
      if (isAdmin) {
        url = `${BACKEND}/api/registroLlamadas?where[quotes][contains]=${serviceQuoteId}&limit=0`
      } else {
        if (userArea.toUpperCase() === "COMERCIAL") { 
          url = `${BACKEND}/api/registroLlamadas?where[quotes][contains]=${serviceQuoteId}&limit=0&where[category][equals]=Comercial`
        } else {
          url = `${BACKEND}/api/registroLlamadas?where[quotes][contains]=${serviceQuoteId}&limit=0&where[category][not_equals]=Administración`
        }
      }

      const response = await axios.get(url)
      setCalls(response.data.docs);
    } catch (error) {
      toast.error("Error al obtener las llamadas");
      return null;
    }
  }

  useEffect(() => {
    getCalls();
  }, [serviceQuoteId]);

  // Función para filtrar llamadas por categoría
  const filterCallsByCategory = (category) => {
    return calls.filter(call => call.category === category);
  };

  return (
    <div className="flex-grow overflow-y-auto">

      {isAdmin && (
        <div className="px-4 mb-6 pt-4 pb-2 top-0 sticky bg-white z-50 shadow-md">
          <h2 className="text-sm font-semibold text-gray-800 mb-2">
            Resumen de llamadas
          </h2>
          <div className="flex flex-row gap-2">
            <p className="text-xs text-gray-800 font-semibold">
              Total de llamadas: {calls.length}
            </p>
            <p className="text-xs text-gray-400">
              |
            </p>
            <p className="text-xs text-gray-800">
              Operativas: {calls.filter(call => call.category === "Operativa").length}
            </p>
            <p className="text-xs text-gray-400">
              |
            </p>
            <p className="text-xs text-gray-800">
              Comercial: {calls.filter(call => call.category === "Comercial").length}
            </p>
            <p className="text-xs text-gray-400">
              |
            </p>
            <p className="text-xs text-gray-800">
              Administración: {calls.filter(call => call.category === "Administración").length}
            </p>
          </div>
        </div>
      )}

      <div className="p-4">
        <CallSection calls={calls} refetch={getCalls} clientData={clientData} quoteId={serviceQuoteId}/>
      </div>
    </div>
  );
};

export default LlamadasSeguimiento;